module.exports = __webpack_public_path__ + "static/media/Hilsbos_Dominic.cd6d40e5.png";